const CATEGORY_LABELS = {
    navigation: 'Навигация',
    auth: 'Авторизация',
    payments: 'Платежи',
    subscriptions: 'Подписки',
    referrals: 'Рефералы',
    account: 'Аккаунт',
    system: 'Система',
    other: 'Прочее',
};

export const CATEGORY_CSS_MODIFIERS = {
    navigation: 'navigation',
    auth: 'auth',
    payments: 'payments',
    subscriptions: 'subscriptions',
    referrals: 'referrals',
    account: 'account',
    system: 'system',
    other: 'other',
};

const SCREEN_LABELS = {
    buy: 'Покупка',
    subscriptions: 'Подписки',
    login: 'Вход',
    register: 'Регистрация',
    account: 'Аккаунт',
    help: 'Справка',
    pricing: 'Тарифы',
    links: 'Ссылки',
};

const TARGET_LABELS = {
    buy: 'Покупка',
    subscriptions: 'Подписки',
    account: 'Аккаунт',
    help: 'Справка',
    pricing: 'Тарифы',
    links: 'Ссылки',
};

const FLOW_LABELS = {
    buy: 'покупка',
    renew: 'продление',
};

export const SALES_FUNNEL_STEPS = [
    { tag: 'page_view', label: 'Заход на сайт', hint: 'все экраны' },
    { tag: 'device_selected', label: 'Выбор устройств' },
    { tag: 'payment_initiated', label: 'Начата оплата' },
    { tag: 'payment_redirect', label: 'Переход к шлюзу' },
    { tag: 'payment_confirm_success', label: 'Оплата успешна' },
];

function formatScreenLabel(screen) {
    return SCREEN_LABELS[screen] || screen;
}

function formatTargetLabel(target) {
    return TARGET_LABELS[target] || target;
}

const METRIC_TAGS = {
    page_view: {
        label: 'Просмотр страницы',
        category: 'navigation',
        formatDetails: (m) => {
            const parts = [];
            if (m?.screen) parts.push(formatScreenLabel(m.screen));
            if (m?.path) parts.push(m.path);
            return parts.join(' · ') || null;
        },
    },
    protected_route_blocked: {
        label: 'Доступ без авторизации',
        category: 'navigation',
        formatDetails: (m) => (m?.from_path ? `откуда: ${m.from_path}` : null),
    },
    help_section_open: {
        label: 'Раздел справки',
        category: 'navigation',
        formatDetails: (m) => (m?.section_id ? `раздел: ${m.section_id}` : null),
    },
    nav_click: {
        label: 'Переход в меню',
        category: 'navigation',
        formatDetails: (m) => (m?.target ? formatTargetLabel(m.target) : null),
    },
    cookie_consent_accepted: {
        label: 'Приняты cookies',
        category: 'system',
    },
    auth_login_success: {
        label: 'Успешный вход',
        category: 'auth',
    },
    auth_login_error: {
        label: 'Ошибка входа',
        category: 'auth',
        formatDetails: (m) => (m?.error_code ? `код: ${m.error_code}` : null),
    },
    auth_register_success: {
        label: 'Успешная регистрация',
        category: 'auth',
    },
    auth_register_error: {
        label: 'Ошибка регистрации',
        category: 'auth',
        formatDetails: (m) => (m?.error_code ? `код: ${m.error_code}` : null),
    },
    auth_logout: {
        label: 'Выход',
        category: 'auth',
    },
    device_selected: {
        label: 'Выбор устройств',
        category: 'payments',
        formatDetails: (m) => (m?.devices != null ? `${m.devices} устр.` : null),
    },
    promo_applied: {
        label: 'Промокод применён',
        category: 'payments',
    },
    promo_failed: {
        label: 'Промокод не сработал',
        category: 'payments',
        formatDetails: (m) => {
            if (m?.error_code) return `код: ${m.error_code}`;
            if (m?.valid === false) return 'невалидный';
            return null;
        },
    },
    points_toggled: {
        label: 'Баллы вкл/выкл',
        category: 'payments',
        formatDetails: (m) => {
            const parts = [];
            if (m?.enabled != null) parts.push(m.enabled ? 'включены' : 'выключены');
            if (m?.amount != null) parts.push(`${m.amount} б.`);
            return parts.join(' · ') || null;
        },
    },
    payment_initiated: {
        label: 'Оплата начата',
        category: 'payments',
        formatDetails: formatPaymentDetails,
    },
    payment_redirect: {
        label: 'Переход к оплате',
        category: 'payments',
        formatDetails: formatPaymentDetails,
    },
    payment_confirm_success: {
        label: 'Оплата подтверждена',
        category: 'payments',
        formatDetails: (m) => {
            const parts = formatPaymentDetails(m) ? [formatPaymentDetails(m)] : [];
            if (m?.payment_id != null) parts.push(`платёж #${m.payment_id}`);
            if (m?.cash_paid != null) parts.push(`${m.cash_paid} ₽`);
            return parts.filter(Boolean).join(' · ') || null;
        },
    },
    payment_confirm_error: {
        label: 'Ошибка подтверждения оплаты',
        category: 'payments',
        formatDetails: (m) => (m?.error_code ? `код: ${m.error_code}` : null),
    },
    subscriptions_loaded: {
        label: 'Загружен список подписок',
        category: 'subscriptions',
        formatDetails: (m) => (m?.count != null ? `${m.count} шт.` : null),
    },
    renew_modal_opened: {
        label: 'Открыто продление',
        category: 'subscriptions',
        formatDetails: (m) => (m?.subscription_id != null ? `подписка #${m.subscription_id}` : null),
    },
    subscription_url_copied: {
        label: 'Скопирован URL подписки',
        category: 'subscriptions',
        formatDetails: (m) => (m?.subscription_id != null ? `#${m.subscription_id}` : null),
    },
    happ_opened: {
        label: 'Открыт Happ',
        category: 'subscriptions',
        formatDetails: (m) => (m?.subscription_id != null ? `#${m.subscription_id}` : null),
    },
    incy_opened: {
        label: 'Открыт INCY',
        category: 'subscriptions',
        formatDetails: (m) => (m?.subscription_id != null ? `#${m.subscription_id}` : null),
    },
    subscription_deleted: {
        label: 'Подписка удалена',
        category: 'subscriptions',
        formatDetails: (m) => (m?.subscription_id != null ? `#${m.subscription_id}` : null),
    },
    referral_code_copied: {
        label: 'Скопирован реф. код',
        category: 'referrals',
    },
    referral_bound_success: {
        label: 'Реф. код привязан',
        category: 'referrals',
    },
    referral_bound_error: {
        label: 'Ошибка привязки реф. кода',
        category: 'referrals',
        formatDetails: (m) => (m?.error_code ? `код: ${m.error_code}` : null),
    },
    password_change_success: {
        label: 'Пароль изменён',
        category: 'account',
    },
    password_change_error: {
        label: 'Ошибка смены пароля',
        category: 'account',
        formatDetails: (m) => (m?.error_code ? `код: ${m.error_code}` : null),
    },
};

function formatPaymentDetails(m) {
    if (!m || typeof m !== 'object') return null;

    const parts = [];
    if (m.devices != null) parts.push(`${m.devices} устр.`);
    if (m.cash_amount != null) parts.push(`${m.cash_amount} ₽`);
    if (m.points != null) parts.push(`${m.points} б.`);
    if (m.promo_applied) parts.push('промокод');
    if (m.flow && FLOW_LABELS[m.flow]) parts.push(FLOW_LABELS[m.flow]);
    if (m.subscription_id != null) parts.push(`подписка #${m.subscription_id}`);

    return parts.length > 0 ? parts.join(' · ') : null;
}

export function getMetricDefinition(tag) {
    return METRIC_TAGS[tag] || null;
}

export function getMetricLabel(tag) {
    return getMetricDefinition(tag)?.label || 'Прочее событие';
}

export function getMetricCategoryKey(tag) {
    return getMetricDefinition(tag)?.category || 'other';
}

export function getMetricCategoryLabel(tag) {
    const key = getMetricCategoryKey(tag);
    return CATEGORY_LABELS[key] || CATEGORY_LABELS.other;
}

export function formatMetricDetails(tag, metadata) {
    const definition = getMetricDefinition(tag);

    if (definition?.formatDetails) {
        const formatted = definition.formatDetails(metadata);
        if (formatted) return formatted;
    }

    if (metadata && typeof metadata === 'object' && Object.keys(metadata).length > 0) {
        return JSON.stringify(metadata);
    }

    return null;
}

export function getMetricTagGroups() {
    const byCategory = {};

    Object.entries(METRIC_TAGS).forEach(([tag, { label, category }]) => {
        if (!byCategory[category]) {
            byCategory[category] = [];
        }
        byCategory[category].push({ tag, label });
    });

    return Object.entries(CATEGORY_LABELS)
        .filter(([key]) => byCategory[key]?.length)
        .map(([key, categoryLabel]) => ({
            category: key,
            categoryLabel,
            tags: byCategory[key].sort((a, b) => a.label.localeCompare(b.label, 'ru')),
        }));
}

export function buildPeriodRange(periodDays, fromDate, toDate) {
    if (fromDate || toDate) {
        const from = fromDate ? new Date(`${fromDate}T00:00:00`) : null;
        const to = toDate ? new Date(`${toDate}T23:59:59`) : new Date();

        return {
            from: from ? from.toISOString() : undefined,
            to: to.toISOString(),
        };
    }

    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - Number(periodDays));
    from.setHours(0, 0, 0, 0);

    return {
        from: from.toISOString(),
        to: to.toISOString(),
    };
}

export function getCountByTag(tagSummary, tag) {
    const row = (tagSummary || []).find((item) => item.tag === tag);
    return row?.count || 0;
}

export function computeSalesKpis(tagSummary) {
    const initiated = getCountByTag(tagSummary, 'payment_initiated');
    const confirmed = getCountByTag(tagSummary, 'payment_confirm_success');
    const errors = getCountByTag(tagSummary, 'payment_confirm_error');
    const conversion = initiated > 0 ? Math.round((confirmed / initiated) * 100) : null;

    return {
        initiated,
        confirmed,
        errors,
        conversion,
    };
}

export function enrichSummaryItem(row) {
    const categoryKey = getMetricCategoryKey(row.tag);

    return {
        ...row,
        label: getMetricLabel(row.tag),
        categoryKey,
        categoryLabel: CATEGORY_LABELS[categoryKey] || CATEGORY_LABELS.other,
    };
}

export function enrichSummaryItems(items) {
    return (items || []).map(enrichSummaryItem);
}

export function filterSummaryByCategory(items, categoryKey) {
    if (!categoryKey) return items || [];

    return (items || []).filter((row) => {
        const key = row.categoryKey || getMetricCategoryKey(row.tag);
        return key === categoryKey;
    });
}

export function getCategoryChips() {
    return [
        { key: '', label: 'Все' },
        ...Object.entries(CATEGORY_LABELS)
            .filter(([key]) => key !== 'other')
            .map(([key, label]) => ({ key, label })),
    ];
}

export function buildFunnelData(tagSummary) {
    return SALES_FUNNEL_STEPS.map((step, index) => {
        const count = getCountByTag(tagSummary, step.tag);
        const prevCount = index > 0
            ? getCountByTag(tagSummary, SALES_FUNNEL_STEPS[index - 1].tag)
            : null;
        const conversionFromPrev = prevCount > 0
            ? Math.round((count / prevCount) * 100)
            : null;

        return {
            ...step,
            count,
            conversionFromPrev,
        };
    });
}

export function getTagsForCategory(categoryKey) {
    if (!categoryKey) {
        return Object.keys(METRIC_TAGS);
    }

    return Object.entries(METRIC_TAGS)
        .filter(([, def]) => def.category === categoryKey)
        .map(([tag]) => tag);
}
